import angular from 'angular';
import { OfficeSearchButtonComponent } from './contact-office-search.component';


export const officeSearchButtonComponent = angular
	.module('officeSearchButton', [])
	.component('officeSearchButton', OfficeSearchButtonComponent)
	.name;
